import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import PrincipalHistorizationSelectionItemViewModelType from '@/ViewModels/Controls/PrincipalHistorizationSelectionItemViewModel';
import LabelType from '@/Controls/Label';
import CheckBoxType from '@/Controls/CheckBox';

export default class PrincipalHistorizationSelectionItem extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private CheckBox = ComponentManager.getControl<typeof CheckBoxType>('CheckBox');
    private jQueryControl: JQuery;
    private label: LabelType;
    private checkbox: CheckBoxType;

    public constructor(private viewModel: PrincipalHistorizationSelectionItemViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<li>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'principalhistorizationselectionitem',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.checkbox.isChecked() === true) {
                        states.push('selected');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            let tuple = this.label.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.checkbox != null) {
            this.checkbox = new this.CheckBox(this.viewModel.checkbox);
            let tuple = this.checkbox.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('PrincipalHistorizationSelectionItem', PrincipalHistorizationSelectionItem, 'RADPresentation.HTMLClient.DefaultViewExtensions');